// extracted by mini-css-extract-plugin
export default {"text":"AppointmentsDetail_text__wy8Gj","textBlue":"AppointmentsDetail_textBlue__8IzYd","buttons":"AppointmentsDetail_buttons__kdy-i"};